import { useParticipant } from "../../contexts/ParticipantContext";
import { Participant } from "../../models/Participant";
import { Field, Label } from "../../design/fieldset";
import { Button } from "../../design/button";
import { XMarkIcon, PlusIcon } from "@heroicons/react/20/solid";
import { useChooseParticipantDialog } from "../../providers/ChooseParticipantDialogProvider";
import { Table, TableBody, TableCell, TableRow } from "../../design/table";

interface SelectParticipantsFieldProps {
  label?: string;
  values: Participant["_id"][];
  onChange: (values: Participant["_id"][]) => void;
  description?: string;
}

const SelectParticipantsField: React.FC<SelectParticipantsFieldProps> = ({
  label,
  values,
  onChange,
  description,
}) => {
  const { participants } = useParticipant();
  const { openDialog } = useChooseParticipantDialog();

  const addParticipant = () => {
    openDialog((participantId) => {
      if (!values.includes(participantId)) {
        onChange([...values, participantId]);
      }
    });
  };

  const removeParticipant = (id: Participant["_id"]) => {
    onChange(values.filter((pid) => pid !== id));
  };

  const selectedParticipants = participants.filter((p) =>
    values.includes(p._id),
  );

  return (
    <Field>
      <div className="flex items-center justify-between mb-2">
        {label && <Label>{label}</Label>}
        <Button onClick={addParticipant} className="mr-1">
          <PlusIcon className="w-4" />
        </Button>
      </div>
      {selectedParticipants.length > 0 ? (
        <div className="overflow-hidden border rounded-lg">
          <Table>
            <TableBody>
              {selectedParticipants.map((participant) => (
                <TableRow key={participant._id}>
                  <TableCell>{participant.name}</TableCell>
                  <TableCell className="text-right">
                    <Button
                      color="red"
                      onClick={() => removeParticipant(participant._id)}
                    >
                      <XMarkIcon className="w-4 h-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <div className="p-2 text-center text-gray-500 border rounded-lg">
          No participants selected.
        </div>
      )}
    </Field>
  );
};

export default SelectParticipantsField;
